// extracted by mini-css-extract-plugin
export var configurationSection = "_s4-0";